import { render, staticRenderFns } from "./Typing.vue?vue&type=template&id=24c51dd2&scoped=true&lang=pug"
import script from "./Typing.vue?vue&type=script&lang=ts"
export * from "./Typing.vue?vue&type=script&lang=ts"
import style0 from "./Typing.vue?vue&type=style&index=0&id=24c51dd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c51dd2",
  null
  
)

export default component.exports